function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "plans-benefits-consult"
}, /*#__PURE__*/React.createElement("path", {
  id: "Stroke 1",
  className: "path",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0509 1H2.94838C1.87677 1 1 1.83572 1 2.85731V8.43983C1 9.46143 1.87677 10.2964 2.94838 10.2964H3.8419V12.7574C3.8419 12.963 4.09458 13.0748 4.25974 12.9433L7.57504 10.2964H10.0509C11.1225 10.2964 12 9.46143 12 8.43983V2.85731C12 1.83572 11.1225 1 10.0509 1Z",
  stroke: "#10B3F0"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group 8"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 3",
  className: "path",
  d: "M4.92969 6.30469C4.65355 6.30469 4.42969 6.08072 4.42969 5.80445C4.42969 5.52818 4.65355 5.30469 4.92969 5.30469C5.20583 5.30469 5.42969 5.52818 5.42969 5.80445C5.42969 6.08072 5.20583 6.30469 4.92969 6.30469",
  stroke: "#10B3F0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 3_2",
  className: "path",
  d: "M7.92969 6.30469C7.65355 6.30469 7.42969 6.08072 7.42969 5.80445C7.42969 5.52818 7.65355 5.30469 7.92969 5.30469C8.20583 5.30469 8.42969 5.52818 8.42969 5.80445C8.42969 6.08072 8.20583 6.30469 7.92969 6.30469",
  stroke: "#10B3F0"
})));
function SvgIconBenefitConsult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefitConsult);
export default __webpack_public_path__ + "static/media/Icon-BenefitConsult.bcf16dcb.svg";
export { ForwardRef as ReactComponent };